import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
// import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import InfoField from 'components/Ui/InfoField'
import { Modal, SimpleTable, Tabs } from 'components/Ui'
import { getApiDetails } from 'services/ShipmentsService'
import { Button } from 'components/Form'
injectReducer('shipments', reducer)

const View = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    // const dispatch = useDispatch()
    const [detailsData, setDetailsData] = useState([])
    const [open, setOpen] = useState(false)
    const [data, setData] = useState()

    const { record, loading } = useSelector(state => state.shipments.data)

    useEffect(() => {
        if (id) {
            // fetchData(id)
            getApiDetails({ order_no: id })
                .then(response => {
                    setDetailsData(response.data.data?.sort((a, b) => a['Line No'] - b['Line No']))
                })
                .catch(error => console.log('Error:', error))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    // const fetchData = id => dispatch(getRecord(id))

    if (loading && id) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Shipments</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 flex justify-between py-3 border-b border-stroke dark:border-strokedark">
                        <h5 className="font-bold">Header</h5>
                        <Button
                            className="h-10 w-18 text-white border bg-[red] border-primary dark:text-secondary dark:border-secondary"
                            onClick={() => navigate('/meson-wms/shipments')}
                        >
                            Back
                        </Button>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <div className="grid grid-cols-4 gap-4">
                            <InfoField title="Warehouse: " value={record?.warehouseId} />
                            <div></div>
                            <InfoField title="Company: " value={record?.organizationId} />
                            <div></div>
                            <InfoField title="Customer: " value={record?.customerId} />
                            <div></div>
                            <InfoField title="Order Number: " value={record?.orderNo} />
                            <div></div>
                            <InfoField title="Order Type: " value={record?.orderType} />
                            <div></div>
                            <InfoField title="Reference A: " value={record?.soReference1} />
                            <div></div>
                            <InfoField title="Reference B: " value={record?.soReference2} />
                            <div></div>
                            <InfoField title="Tracking Number: " value={record?.deliveryNo} />
                            <div></div>
                            <InfoField title="Consignee Name: " value={record?.consigneeName} />
                            <div></div>
                            <InfoField title="Order Time: " value={record?.orderTime} />
                            <div></div>
                            <InfoField title="last Shipment Time: " value={record?.lastShipmentTime} />
                            <div></div>
                            <InfoField title="Order Status: " value={record?.codeDescr} />
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <Tabs.Group version={1}>
                        <Tabs.List>
                            <Tabs>Details</Tabs>
                        </Tabs.List>
                        <Tabs.Panels className="mt-4">
                            <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Line No.</SimpleTable.TH>
                                                <SimpleTable.TH>SKU</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                                <SimpleTable.TH>Ordered Quantity</SimpleTable.TH>
                                                <SimpleTable.TH>Shipped Quantity</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(detailsData ?? []).map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`asn-${index}`}
                                                    onClick={() => {
                                                        setOpen(true)
                                                        setData(item)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.['Line No']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['SKU']}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.['Description']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Ordered Quantity']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Shipped Quantity']}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel>
                        </Tabs.Panels>
                    </Tabs.Group>
                </div>
                <Modal
                    show={open}
                    onClose={() => {
                        setOpen(false)
                    }}
                >
                    <div className="flex flex-col gap-1 m-3">
                        <h2 className="font-semibold text-black text-title-md">{'Details'}</h2>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                            <div className="flex flex-col gap-3 py-6 px-8">
                                <div className="grid grid-cols-1 gap-4">
                                    <InfoField grid={false} title="Wharehouse: " value={data?.warehouseId} />
                                    <InfoField grid={false} title="Company: " value={data?.organizationId} />
                                    <InfoField grid={false} title="Order Number: " value={data?.orderNo} />
                                    <InfoField grid={false} title="Customer: " value={data?.customerId} />
                                    <InfoField grid={false} title="Line No.: " value={data?.orderLineNo} />
                                    <InfoField grid={false} title="Product: " value={data?.sku} />
                                    <InfoField grid={false} title="Trace Id: " value={data?.traceId} />
                                    <InfoField grid={false} title="Ordered Quantity: " value={data?.qtyOrdered} />
                                    <InfoField grid={false} title="Allocated Quantity: " value={data?.qtyAllocated} />
                                    <InfoField grid={false} title="Picked Quantity: " value={data?.qtyPicked} />
                                    <InfoField grid={false} title="Shipped Quantity: " value={data?.qtyShipped} />
                                    <InfoField grid={false} title="Pack Id: " value={data?.packId} />
                                    <InfoField grid={false} title="Pack UOM: " value={data?.packUom} />
                                    <InfoField grid={false} title="Rotation Id: " value={data?.rotationId} />
                                    <InfoField grid={false} title="Allocation Rule: " value={data?.allocationRule} />
                                    <InfoField grid={false} title="Cubic: " value={data?.cubic} />
                                    <InfoField grid={false} title="Gross-Weight: " value={data?.grossWeight} />
                                    <InfoField grid={false} title="Net-Weight: " value={data?.netWeight} />
                                    <InfoField grid={false} title="Price: " value={data?.price} />
                                    <InfoField grid={false} title="Description: " value={data?.Description} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    )
}

export default View
